import React from 'react'

function BannerHolder({children,bannerclass}){
    return(
        <div className={bannerclass}>
            {children}
        </div>
    )
}

export default BannerHolder